import React, { ChangeEvent, useEffect, useState } from "react";
import SlotInput from './SlotInput';
// import SlotType from "./Interfaces/SlotType";
import { baseAPIUrl } from "../../../Utils/BaseAPI";
import axios, { AxiosResponse } from "axios";
import BoxType from "./Interfaces/BoxType";
import { Slot } from "./Interfaces/SlotType";
import { useNavigate, useParams } from "react-router-dom";
import { FieldExtractor } from "../../../Utils/field-extractor";
import { convertFirstLetterToLowerCase } from "../../../Utils/BaseUtils";
import LineType from "./Interfaces/LineInterface";

import { ChromePicker } from 'react-color';

interface LineTypeProps {
    formData: LineType;
    setFormData: React.Dispatch<React.SetStateAction<LineType>>;
}

const CreateOrEdit: React.FC<LineTypeProps> = ({ formData, setFormData }) => {

    const navigate = useNavigate();

    const [data, updateData] = useState<any>();

    const { id } = useParams();
    const editAction = `${baseAPIUrl}GetLine`;

    const [color, setColor] = useState(data?.color || '#fff'); // Valore iniziale del colore
    const [showColorPicker, setShowColorPicker] = useState(false);

    const handleColorChange = (newColor: any) => {
        setColor(newColor.hex || '');

        let name = 'color';
        let value = newColor.hex;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const handleInputClick = () => {
        const bool = showColorPicker;
        setShowColorPicker(!bool);
    };

    /* const [formData, setFormData] = useState<FormData>({
        boxId: '',
        name: '',
        displayName: '',
        color: '',
        address: '',
        locationInfo: '',
        wareHouse: '',
        slots: [] as Slot[],
        isArchived: false
    }); */

    const [boxes, setBoxes] = useState<BoxType[]>([]);
    const [drivers, setDrivers] = useState<any[]>([]);

    useEffect(() => {
        if (id) {
            axios.get(`${editAction}?id=${id}`)
                .then((result: AxiosResponse) => {
                    if (result && result.data) {
                        if (result.data.Slots.length > 0) {
                            result.data.Slots = result.data.Slots.map((el: any) => {
                                if (el.AssociatedDriver && el.AssociatedDriver.Id) {
                                    el.AssociatedDriverId = el.AssociatedDriver.Id;
                                }
                                return el;
                            });
                        }
                        updateData(result.data);
                    }
                });
        }
    }, [id]);

    useEffect(() => {
        if (data) {
            data.boxId = data.Box.Id;
            let dataFormatted = FieldExtractor.extractObjectField(data, '', null, true) as LineType;
            setFormData(dataFormatted);
            setColor(data.Color);
        }
    }, [data]);

    useEffect(() => {
        getBoxes();
    }, []);

    useEffect(() => {
        getDriverByBoxId();
    }, [formData.boxId]);

    useEffect(() => {
        let slots = formData.slots;
        slots.forEach((slot, index) => {
            slot.index = index + 1;
        });
    }, [formData.slots]);

    const getBoxes = () => {
        axios.post(baseAPIUrl + 'GetBoxes')
            .then((result: AxiosResponse) => {
                if (result && result.data && result.data.Boxes) {
                    setBoxes(result.data.Boxes);
                }
            })
    }

    const getDriverByBoxId = () => {
        let boxId = formData.boxId;
        if (boxId) {
            axios.post(baseAPIUrl + 'GetDriversByBox', {
                BoxId: formData.boxId
            })
                .then((result: AxiosResponse) => {
                    if (result && result.data && result.data.Drivers) {
                        setDrivers(result.data.Drivers);
                    }
                })
        }

    }

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        let { name, value } = event.target;
        name = convertFirstLetterToLowerCase(name);
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const handleAddSlot = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            slots: [
                ...prevFormData.slots,
                new Slot(prevFormData.slots.length + 1)
            ]
        }));
    };

    const handleUpdateSlot = (index: number, updatedSlot: Slot) => {
        setFormData((prevFormData) => {
            const updatedSlots = prevFormData.slots.map((slot, i) => {
                if (i === index) {
                    return {
                        ...updatedSlot,
                        // Parent: {
                        //     Index: updatedSlot.Index
                        // }
                    };
                }
                return slot;
            });

            return {
                ...prevFormData,
                slots: updatedSlots
            };
        });
    };

    const handleDeleteSlot = (index: number) => {
        setFormData((prevFormData) => {
            const updatedSlots = [...prevFormData.slots];
            updatedSlots.splice(index, 1);
            updatedSlots.map((slot, index) => {
                if (index == 0 && slot.parent) {
                    slot.parent.index = 0;
                }
                slot.index = index + 1;
                return slot;
            })
            return {
                ...prevFormData,
                slots: updatedSlots
            };
        });
    };

    const redirectBack = () => {
        navigate('/configurations/linea');
    };

    return (
        <React.Fragment>
            <button className="mt-20 back-button" onClick={redirectBack}>Indietro</button>
            <h2 className="page-title mb-20 mt-15">{
                id !== undefined && id !== null ? 'Modifica la linea' : 'Inserisci una nuova linea'}</h2>
            <div className="input-row">
                <div className="input-box">
                    <label className="input-label required">
                        BoxId
                    </label>
                    <select
                        name="BoxId"
                        required
                        value={formData.boxId}
                        className='input-select'
                        onChange={handleInputChange}
                    >
                        <option value="DEFAULT" hidden disabled>Seleziona una box</option>
                        {boxes?.map((el) => {
                            return (
                                <option
                                    value={el.Id}
                                    key={`box-${el.Id}`}
                                >{el.BoxName}</option>
                            )
                        })}
                    </select>
                </div>
            </div>
            <div className="input-row">
                <div className="input-box">
                    <label className="input-label required">
                        Name
                    </label>
                    <input
                        className="input-field"
                        type="text"
                        name="Name"
                        required
                        value={formData.name}
                        onChange={handleInputChange}
                    />
                </div>
                <div className="input-box">
                    <label className="input-label required">
                        DisplayName
                    </label>
                    <input
                        className="input-field"
                        type="text"
                        name="DisplayName"
                        required
                        value={formData.displayName}
                        onChange={handleInputChange}
                    />
                </div>
            </div>
            <div className="input-row">
                <div className="input-box">
                    <label className="input-label required">
                        Color
                    </label>
                    <div>
                        <input
                            className="input-field"
                            name="Color"
                            value={color}
                            onChange={(e: any) => handleColorChange(e.target.value)}
                            onClick={handleInputClick}
                        />
                        {showColorPicker && (
                            <div style={{ position: 'relative'}}>
                            <ChromePicker color={color} onChange={handleColorChange} />
                            <button onClick={handleInputClick} className="close-button-cp">Salva</button>
                            </div>
                        )}
                    </div>
                </div>
                <div className="input-box">
                    <label className="input-label">
                        Address
                    </label>
                    <input
                        className="input-field"
                        type="text"
                        name="Address"
                        value={formData.address}
                        onChange={handleInputChange}
                    />
                </div>
            </div>
            <div className="input-row">
                <div className="input-box">
                    <label className="input-label">
                        LocationInfo
                    </label>
                    <input
                        className="input-field"
                        type="text"
                        name="LocationInfo"
                        value={formData.locationInfo}
                        onChange={handleInputChange}
                    />


                </div>
                <div className="input-box">
                    <label className="input-label">
                        WareHouse
                    </label>
                    <input
                        className="input-field"
                        type="text"
                        name="WareHouse"
                        value={formData.wareHouse}
                        onChange={handleInputChange}
                    />
                </div>
            </div>
            {formData.slots.map((slot, index) => (
                <SlotInput
                    index={index}
                    drivers={drivers}
                    key={index}
                    slot={slot}
                    slots={formData.slots}
                    onUpdateSlot={(updatedSlot) => handleUpdateSlot(index, updatedSlot)}
                    onDeleteSlot={() => handleDeleteSlot(index)}
                />
            ))}

            <a className="add-item-link mt-10" onClick={handleAddSlot}>
                + Aggiungi slot
            </a>

            {/* <label>
                IsArchived:
                <input
                    type="checkbox"
                    name="IsArchived"
                    checked={formData.IsArchived}
                    onChange={handleInputChange}
                />
            </label>
            <br /><br /> */}
            <button type="submit" className="submit-button mt-20 mb-40">Salva</button>
        </React.Fragment>
    );
}

export default CreateOrEdit;